module.exports = __webpack_public_path__ + "img/kx6.d0ca4dfa.png";